import { ElementRef } from '@angular/core'

export abstract class TlwBaseCompnent {
  constructor(public element: ElementRef) {}
}
